module.exports = __webpack_public_path__ + "static/media/tailoring.c4d1b0b2.svg";